import { assets } from "../../mock";
import { ArrowDown } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="hero">
      <div className="hero-bg" />
      <div className="hero-visual">
        <img src={assets.heroVisual} alt="ODDA architectural residence rendering" />
        <div className="hero-visual__frame" />
      </div>
      <div className="wrap hero-content">
        <div className="hero-top">
          <div className="eyebrow">
            <span className="eyebrow-dot" />
            Toronto · Canada
          </div>
          <div className="hero-index">01 / 08</div>
        </div>

        <h1 className="hero-title reveal is-visible">
          Spaces that
          <br />
          <span className="accent">define lifestyles.</span>
        </h1>

        <div className="hero-bottom reveal is-visible">
          <p className="hero-lede">
            ODDA Corp. is an architecture, design, and development practice creating spaces of enduring character — considered, refined, and unmistakably ODDA.
          </p>
          <a className="scroll-note" href="#statement">
            <ArrowDown size={14} />
            <span>Explore the studio</span>
          </a>
        </div>
      </div>

      <div className="hero-marquee">
        <div className="hero-marquee__track">
          {Array.from({ length: 2 }).map((_, i) => (
            <span key={i}>
              Architecture — Design — Development — Quiet Luxury — Sculptural Form — Enduring Place —
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
